import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { useOrganizations } from '@/shared/hooks/useOrganizations';
import { useAuthStore } from '@/core/stores/auth.store';

export function usePostLoginRedirect(enabled = true) {
  const navigate = useNavigate();
  const user = useAuthStore((s) => s.user);
  const tokens = useAuthStore((s) => s.tokens);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const activeOrgId = useOrganizationStore((s) => s.activeOrganizationId);
  const setActiveOrganization = useOrganizationStore((s) => s.setActiveOrganization);
  const { data: organizations = [], isLoading, isSuccess } = useOrganizations();
  const hasTriggered = useRef(false);

  useEffect(() => {
    if (
      !enabled ||
      !user ||
      !tokens ||
      !isAuthenticated() ||
      hasTriggered.current ||
      isLoading ||
      !isSuccess
    ) {
      return;
    }

    hasTriggered.current = true;

    if (organizations.length === 0) {
      navigate('/onboarding', { replace: true });
      return;
    }

    const targetOrgId = activeOrgId ?? organizations[0].id;
    setActiveOrganization(targetOrgId);
    navigate(`/${targetOrgId}/members`, { replace: true });
  }, [
    user,
    tokens,
    isLoading,
    isSuccess,
    organizations,
    activeOrgId,
    enabled,
    navigate,
    isAuthenticated,
    setActiveOrganization,
  ]);
}
